import React, { useState } from 'react';
import AddressBookManager from '../../components/common/AddressBookManager';

const AddressBookPage = () => {
  const [showManager, setShowManager] = useState(false);

  return (
    <div className="max-w-7xl mx-auto px-4 py-6">
      <div className="bg-white rounded-lg shadow p-6">
        <div className="flex justify-between items-center mb-6">
          <div>
            <h1 className="text-2xl font-bold text-gray-900">Address Book</h1>
            <p className="text-gray-600 mt-1">
              Manage your customer addresses for quick delivery selection
            </p>
          </div>
          <button
            onClick={() => setShowManager(true)}
            className="px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700"
          >
            Manage Addresses
          </button>
        </div>

        <div className="bg-blue-50 border border-blue-200 rounded-lg p-4">
          <h3 className="font-medium text-blue-900 mb-2">How it works:</h3>
          <ul className="text-sm text-blue-800 space-y-1">
            <li>• Add your customers' addresses to your address book</li>
            <li>• When creating a quote, select "Express Delivery" and click "Select from Address Book"</li>
            <li>• Choose a customer from your saved addresses to auto-fill delivery details</li>
            <li>• Set a default address for quick access</li>
          </ul>
        </div>
      </div>

      <AddressBookManager
        isOpen={showManager}
        onClose={() => setShowManager(false)}
      />
    </div>
  );
};

export default AddressBookPage;
